import React from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';

export const CatchYearCompletionPie = ({
                                         completedCount,
                                         totalCount
                                       }: {
  completedCount: number;
  totalCount?: number;
}) => {
  const hasTotal = typeof totalCount === 'number' && totalCount > 0;
  const remaining = hasTotal ? Math.max((totalCount as number) - completedCount, 0) : 0;
  const data = hasTotal
    ? [
      {name: 'Abgeschlossen', value: completedCount},
      {name: 'Offen', value: remaining}
    ]
    : [];

  const COLORS = ['#2fb344', '#adb5bd']; // grün, grau

  const percentage =
    hasTotal && totalCount
      ? Math.round((completedCount / totalCount) * 100)
      : undefined;

  return (
    <div className="card shadow-sm h-100 d-flex flex-column">
      <div className="card-header">
        <h3 className="card-title">Abschluss Fangjahr</h3>
      </div>
      <div className="card-body flex-grow-1 d-flex flex-column" style={{minHeight: 0}}>
        {!hasTotal ? (
          <div className="text-muted">
            Bitte Gesamtzahl angeben, um den Abschluss in % anzuzeigen.
          </div>
        ) : (
          <>
            <div className="mb-2">
              <strong>{percentage}%</strong> abgeschlossen ({completedCount} von {totalCount})
            </div>
            <div style={{height: 260}}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={70}
                    outerRadius={100}
                    paddingAngle={2}
                  >
                    {data.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
